<template lang="pug">
w-input.f-username(
  v-bind=`{ value, label, required }`
  ref='input'
  @input='input'
)
</template>

<script lang="js">
import WInput, { mixin } from '@/widgets/w-input'

export default {
  name: 'UsernameField',
  mixins: [ mixin ],
  components: { WInput },
  props: {
    label: {
      type: String,
      default: 'username'
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.f-username {

}
</style>
